@if (item(); as item) {
  <cx-media
    class="carousel-item--media"
    [container]="item.image"
    [alt]="item.description"
    loading="lazy"
  ></cx-media>
  <div class="carousel-item--details">
    <p class="carousel-item--title">{{ item.description }}</p>
    @if (item.link?.url) {
      <cx-generic-link
        [tabindex]="0"
        [class]="'btn btn-secondary carousel-item--btn'"
        [url]="item.link.url"
        [attr.rel]="item.link.url ? 'noopener noreferrer' : null"
      >{{ item.link.label || ('dpNews.readMore' | cxTranslate) }}
      </cx-generic-link>
    }
  </div>
}
